import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CMS } from '../../utils/CMS';
import { FlightClass, FlightClassCMS, FlightClassProp } from '../../models/FlightClass';
import { ConnectedFlightClassSelector } from './FlightClassSelector';
import { RadioButton } from '../../components/RadioButton';
import { ABUtils } from '../../utils';

const FlightClassSelectorInner = ({ onChange, value }) => {
    const { isCssVariationMobile } = ABUtils.getABs();
    const items = Object.keys(FlightClass);

    const classNames = classnames({
        'odf-space-outer-right-m': !isCssVariationMobile,
        'prisma-responsive-space-horizontal odf-space-inner-top-m odf-space-inner-bottom-m': isCssVariationMobile,
    });
    const itemClassNames = classnames({
        'odf-selectable': !isCssVariationMobile,
        'prisma-selectable odf-space-outer-top-m odf-space-outer-bottom-m': isCssVariationMobile,
    });
    const childClassNames = classnames({
        'odf-text-mono-color-02 odf-text-md odf-space-inner-left-s': isCssVariationMobile,
    });

    return (
        <div className={classNames}>
            {items.map((item, i, arr) => {
                const onChangeWrapper = () => onChange(item);
                const checked = item === value;
                const cms = FlightClassCMS[item];
                const id = `cabinClass_${item}`;

                return (
                    <div key={item}>
                        <div className={itemClassNames}>
                            <RadioButton checked={checked} onChange={onChangeWrapper} id={id}>
                                <span className={childClassNames}>
                                    <CMS id={cms} />
                                </span>
                            </RadioButton>
                        </div>
                        {isCssVariationMobile && i !== arr.length -1 && (
                            <div className="odf-separator-dotted" />
                        )}
                    </div>
                );
            })}

        </div>
    );
};

FlightClassSelectorInner.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: FlightClassProp.isRequired,
};

export const FlightClassSelector = () => (
    <ConnectedFlightClassSelector render={({ onChange, value }) => (
        <FlightClassSelectorInner onChange={onChange} value={value} />
    )}
    />
);


